module.exports = __webpack_public_path__ + "img/troubleshooting-icon.749463a2.svg";